<template>
    <div>

        <headline>
            Schreibtische
            <template v-slot:more>
                <desk-create class="mr-2" @created="load"></desk-create>
                <schedule-create v-show="can.create.schedule" class="mr-2"></schedule-create>
                <a v-show="group.has_check_in" href="/admin/qr_codes" target="_blank" class="mr-2">
                    <button-secondary class="w-full mr-2">
                        <template slot="icon"><i class="fa fa-print"></i></template>
                        QR-Codes drucken
                    </button-secondary>
                </a>
                <button-secondary @click="download">
                    <template slot="icon"><i class="fa fa-download"></i></template>
                    Daten exportieren
                </button-secondary>
            </template>
        </headline>
        <div>
            <ul class="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                <li>
                    <a class="col-span-1 flex shadow-sm rounded-md" href="/admin/pages/floors">
                        <div
                            class="flex-shrink-0 flex items-center justify-center w-16 bg-pink-600 text-white text-sm font-medium rounded-l-md">
                            E
                        </div>
                        <div
                            class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                            <div class="flex-1 px-4 py-2 text-sm truncate">
                                <span class="text-gray-900 font-medium hover:text-gray-600">Etagen</span>
                                <p class="text-gray-500">{{ floors.length }}</p>
                            </div>
                            <div class="flex-shrink-0 pr-2">
                                <button
                                    class="w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    <i class="fa fa-pencil"></i>
                                </button>
                            </div>
                        </div>
                    </a>
                </li>

                <li class="">
                    <a class="col-span-1 flex shadow-sm rounded-md" href="/admin/pages/zones">
                        <div
                            class="flex-shrink-0 flex items-center justify-center w-16 bg-purple-600 text-white text-sm font-medium rounded-l-md">
                            Z
                        </div>
                        <div
                            class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
                            <div class="flex-1 px-4 py-2 text-sm truncate">
                                <span class="text-gray-900 font-medium hover:text-gray-600">Zonen</span>
                                <p class="text-gray-500">{{ groups.length }}</p>
                            </div>
                            <div class="flex-shrink-0 pr-2">
                                <button
                                    class="w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    <i class="fa fa-pencil"></i>
                                </button>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>

        <loading v-show="loading"></loading>

        <div v-show="!loading" class="mt-8">

            <desk-groups @load="load" :groups="groups" :desks="desks" :has-filter="true"></desk-groups>

        </div>
    </div>
</template>

<script>

import DeskItem from "./DeskTableItem.vue";
import Modal from "./Modal";
import ButtonPrimary from "./UI/ButtonPrimary";
import TailwindTable from "./UI/TailwindTable";
import InputText from "./UI/InputText";
import ButtonSecondary from "./UI/ButtonSecondary";
import FullCard from "./UI/FullCard";
import Popup from "./Popup";
import DeskCreate from "./DeskCreate";
import ZoneCreate from "./ZoneCreate";
import Loading from "./UI/Loading";
import ButtonWhite from "./UI/ButtonWhite";
import Accordion from "./UI/Accordion";
import AccordionItem from "./UI/AccordionItem";
import ZoneEdit from "./ZoneEdit";
import Headline from "./UI/Headline";
import ScheduleCreate from "./ScheduleCreate";
import Tabs from "./UI/Tabs";
import DeskGroups from "./DeskGroups";

export default {

    components: {
        DeskGroups,
        Tabs,
        ScheduleCreate,
        Headline,
        ZoneEdit,
        AccordionItem,
        Accordion,
        ButtonWhite,
        Loading,
        ZoneCreate,
        DeskCreate,
        Popup,
        FullCard,
        ButtonSecondary,
        InputText,
        TailwindTable,
        ButtonPrimary,
        Modal,
        DeskItem,
    },

    data() {
        return {
            loading: false,
            desks: [],
            groups: [],
            types: [],
            floors: [],
            qrCode: '',

            sortType: 'name',
            sortDesc: false,
        };
    },

    inject: ['group', 'can'],

    created() {
        this.load();
    },

    computed: {
        items() {
            return this.desks.sort((a, b) => {
                let valA = a[this.sortType] ? a[this.sortType].toString().toLowerCase() : null;
                let valB = b[this.sortType] ? b[this.sortType].toString().toLowerCase() : null;

                if (valA < valB) {
                    return this.sortDesc ? 1 : -1;
                }

                if (valA > valB) {
                    return this.sortDesc ? -1 : 1;
                }

                return 0;
            });
        },
    },

    methods: {
        load() {
            this.loading = true;
            axios.get('/admin/desks').then(response => {
                this.desks = response.data.desks;
                this.groups = response.data.groups;
                this.floors = response.data.floors;
                this.types = response.data.types;

                this.qrCode = response.data.desks[0]?.qr_code;
                this.loading = false;
            }).catch(error => {
                this.$root.$emit('error', error);
            });
        },
        remove(item) {
            window.axios.post('/admin/desks/' + item.id, {
                '_method': 'delete',
            })
                .then(() => {
                    this.desks.splice(this.desks.indexOf(item), 1);
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                });
        },
        download() {
            window.open('/admin/desks/export');
        }
    }
}

</script>
